/* Ghost Bin Halloween gift: auto-add the free ghost when the cart reaches $75 (Oct 21-31, 2026).
   Picks the 1/4" or SKADIS version from what is in the cart. Removes it again if the cart drops under $75.
   Self-disables after Oct 31, 2026. Safe to delete after that date, together with ghost-gift-popup.css. */
(function () {
  if (Date.now() > Date.UTC(2026, 10, 1, 4)) return; // Nov 1 2026, 00:00 ET
  var GIFT_QUARTER = 68145059463472, GIFT_SKADIS = 68145059496240, MIN_CENTS = 7500;
  var FLAG = 'ghostGiftAdded', busy = false;
  var JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  function systemOf(item) {
    var text = (item.product_title || '') + ' ' + (item.variant_title || '') + ' ' + JSON.stringify(item.properties || {});
    if (/skadis/i.test(text)) return 'skadis';
    if (text.indexOf('1/4') > -1) return 'quarter';
    return '';
  }
  function flag(set) { try { if (set) sessionStorage.setItem(FLAG, '1'); else sessionStorage.removeItem(FLAG); } catch (e) {} }
  function hasFlag() { try { return sessionStorage.getItem(FLAG) === '1'; } catch (e) { return false; } }
  function getCart() { return fetch('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function announce() {
    return getCart().then(function (cart) {
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: cart, sourceId: 'ghost-gift', data: { itemCount: cart.item_count, source: 'ghost-gift' } };
      document.dispatchEvent(ev);
    });
  }
  function run() {
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      var gift = null, subtotal = 0, value = { quarter: 0, skadis: 0 };
      cart.items.forEach(function (item) {
        if (item.variant_id === GIFT_QUARTER || item.variant_id === GIFT_SKADIS) { gift = item; return; }
        subtotal += item.original_line_price;
        var s = systemOf(item);
        if (s) value[s] += item.original_line_price;
      });
      var eligible = subtotal >= MIN_CENTS;
      if (eligible && !gift) {
        if (hasFlag()) return; // the customer took it out on purpose this session
        var variant = value.skadis > value.quarter ? GIFT_SKADIS : GIFT_QUARTER;
        return fetch('/cart/add.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: [{ id: variant, quantity: 1 }] }) })
          .then(function (r) { if (r.ok) { flag(true); return announce(); } });
      }
      if (gift && (!eligible || gift.quantity > 1)) {
        return fetch('/cart/change.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: gift.key, quantity: eligible ? 1 : 0 }) })
          .then(function (r) { if (r.ok) { if (!eligible) flag(false); return announce(); } });
      }
    }).catch(function () {}).then(function () { busy = false; });
  }
  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.sourceId === 'ghost-gift') return;
    setTimeout(run, 200);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
